import { render } from "./CategoryCard.vue?vue&type=template&id=e8b60812&scoped=true&ts=true"
import script from "./CategoryCard.vue?vue&type=script&lang=ts"
export * from "./CategoryCard.vue?vue&type=script&lang=ts"

import "./CategoryCard.vue?vue&type=style&index=0&id=e8b60812&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b60812"]])

export default __exports__